module.exports = __webpack_public_path__ + "img/peixun.1d873de7.svg";